<div class="contents-area">
  <div class="column-list">
    <label class="list-input-title">媒体</label>
    <div class="list-input-content" style="width: 300px;">
      <app-koma-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'" editable="false"
        [forcedEnabledMode]="'true'" [tabindex]="0" [initFocusItem]="cmb_MediumType" [required]="true"
        (change)="eventMediumType_CHANGEHandler()" style="width: 100%;">
      </app-koma-medium-type-combo-box>
    </div>
  </div>
  <div class="split_two_part">
    <div style="flex:1;">
      <h1>ページネーション選択</h1>
      <div class="element-column">
        <div class="column-list" style="width:100%;">
          <label class="list-input-title">適用開始受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txt_OrderCodeFrom" #txt_OrderCodeFrom [subid]="'txt_OrderCodeFrom'"
              [catalogIDField]="lbl_DelivCatalogIdFrom" [tabindex]="0" [forcedEnabledMode]="'true'" [required]="true">
            </app-order-code-text-input>
            <label>～</label>
            <app-order-code-text-input id="txt_OrderCodeTo" #txt_OrderCodeTo [subid]="'txt_OrderCodeTo'"
              [catalogIDField]="lbl_DelivCatalogIdTo" [tabindex]="0" [forcedEnabledMode]="'true'">
            </app-order-code-text-input>
          </div>
          <label class="list-input-title">配達企画回(翌週)</label>
          <div class="list-input-content">
            <input type="text" id="lbl_DelivCatalogIdFrom" #lbl_DelivCatalogIdFrom class="deliv-catalog" readonly>
            <label>～</label>
            <input type="text" id="lbl_DelivCatalogIdTo" #lbl_DelivCatalogIdTo class="deliv-catalog" readonly>
          </div>
        </div>
        <div class="block-row">
          <button id="btn_Display" class="btn-secondary" #btn_Display [tabindex]="0" (click)="eventDisplay_CLICKHandler()"
            forcedEnabledMode="true">表示</button>
        </div>
        <wj-flex-grid #dtg_PagenationList [itemsSource]="kymw2500Model.pagenationList" id="dtg_PagenationList"
          class="space-bottom" [headersVisibility]="'Column'" class="wj-flexgrid" [isReadOnly]="true"
          [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'None'" [tabindex]="0"
          (selectionChanged)="eventPagenationList_CHANGEHandler()" forcedEnabledMode="true" [style.width.px]="793">
          <wj-flex-grid-column [minWidth]="5" [header]="'適用開始受注コード'" [width]="150" [binding]="'OrderCode'"
            [multiLine]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'開始配達企画回(翌週)'" [width]="200" [binding]="'DelivCatalogId'"
            [multiLine]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="140" [binding]="'Group'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'基版頁作成生協'" [width]="284" [binding]="'PlanCoopName'"
            [multiLine]="true">
          </wj-flex-grid-column>
        </wj-flex-grid>
        <div class="layout_balance short-buttons">
          <button id="btn_Delete" class="btn-tartiary" #btn_Delete [tabindex]="0"
            (click)="eventDelete_CLICKHandler()">ページネーション設定を削除</button>
          <div class="block-row">
            <button id="btn_Copy" class="btn-secondary" #btn_Copy [tabindex]="-1"
              (click)="eventCopy_CLICKHandler()">コピー</button>
            <button id="btn_Output" class="btn-secondary" #btn_Output [tabindex]="0"
              (click)="eventOutput_CLICKHandler()">出力</button>
            <button id="btn_Add" class="btn-secondary" #btn_Add [tabindex]="0" (click)="eventAdd_CLICKHandler()">追加</button>
            <button id="btn_Edit" class="btn-secondary" #btn_Edit [tabindex]="0"
              (click)="eventEdit_CLICKHandler()">編集</button>
          </div>
        </div>
      </div>
    </div>
    <div style="flex:1;">
      <h1>ページネーション詳細</h1>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">適用開始受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_OrderCode" #txt_OrderCode [subid]="'txt_OrderCode'"
                [catalogIDField]="lbl_DelivCatalogId" [(ngModel)]="kymw2500Model.orderCode" [tabindex]="0" [disabled]="true"
                [required]="true" (ngModelChange)="eventOrderCode_CHANGEHandler()">
              </app-order-code-text-input>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" id="lbl_DelivCatalogId" #lbl_DelivCatalogId class="deliv-catalog" readonly>
            </div>
          </div>
        </div>
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">グループ</label>
            <div class="list-input-content" style="width: 98px;">
              <input type="text" style="width:3rem;" id="txt_Grp" #txt_Grp readonly [(ngModel)]="kymw2500Model.group">
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">基版ページ作成生協</label>
            <div class="list-input-content">
              <app-coop-code-combo-box id="cmb_CoopCode" #cmb_CoopCode [subid]="'cmb_CoopCode'" [tabindex]="0"
                [required]="true" (change)="eventCoopCode_CHANGEHandler()">
              </app-coop-code-combo-box>
            </div>
          </div>
        </div>
        <div class="block-row">
          <button id="btn_Unset" class="btn-secondary" #btn_Unset [tabindex]="-1"
            (click)="eventUnset_CLICKHandler()">未設定</button>
          <button id="btn_Initialize" class="btn-secondary" #btn_Initialize [tabindex]="-1"
            (click)="eventInitialize_CLICKHandler()">初期化</button>
        </div>
        <wj-flex-grid #dtg_PagenationDetail [itemsSource]="kymw2500Model.pagenationDetail" id="dtg_PagenationDetail"
          class="space-bottom" [headersVisibility]="'Column'" class="wj-flexgrid" [style.height.px]="289" [style.width.px]="803"
          [isReadOnly]="readonlyPagenationDetail" [selectionMode]="'Row'" [allowSorting]="false" [tabindex]="0"
          (focus)="eventPagenationDetail_ITEM_FOCUS_INHandler()" (pasting)="onPasting($event)">
          <wj-flex-grid-column [minWidth]="5" [header]="headerKihanPage" [width]="87"
            [binding]="'KihanPage'" id="dgc_KihanPage" [visible]="kymw2500Model.visibleKihanPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'いばらき'" [width]="87" [binding]="'IbarakiPage'"
            id="dgc_IbarakiPage" [visible]="kymw2500Model.visibleIbarakiPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'とちぎ'" [width]="87" [binding]="'TochigiPage'"
            id="dgc_TochigiPage" [visible]="kymw2500Model.visibleTochigiPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ぐんま'" [width]="87" [binding]="'GunnmaPage'"
            id="dgc_GunnmaPage" [visible]="kymw2500Model.visibleGunnmaPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ちば'" [width]="87" [binding]="'ChibaPage'"
            id="dgc_ChibaPage" [visible]="kymw2500Model.visibleChibaPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'さいたま'" [width]="87" [binding]="'SaitamaPage'"
            id="dgc_SaitamaPage" [visible]="kymw2500Model.visibleSaitamaPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'とうきょう'" [width]="87" [binding]="'TokyoPage'"
            id="dgc_TokyoPage" [visible]="kymw2500Model.visibleTokyoPage" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ながの'" [width]="87" [binding]="'NaganoPage'"
            id="dgc_NaganoPage" [visible]="kymw2500Model.visibleNaganoPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'にいがた'" [width]="87" [binding]="'NiigataPage'"
            id="dgc_NiigataPage" [visible]="kymw2500Model.visibleNiigataPage" [align]="'left'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'クルコ'" [width]="87" [binding]="'KurucoPage'" id="dgc_KurucoPage"
            [visible]="kymw2500Model.visibleKurucoPage" [align]="'left'">
          </wj-flex-grid-column>
        </wj-flex-grid>
        <div class="layout_balance short-buttons">
          <button id="btn_DeletePage" class="btn-tartiary" #btn_DeletePage [tabindex]="0"
            (click)="eventDeletePage_CLICKHandler()">ページを削除</button>
          <button id="btn_AddPage" class="btn-secondary" #btn_AddPage [tabindex]="0"
            (click)="eventAddPage_CLICKHandler()">ページを追加</button>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer-buttons">
      <button id="btn_Set" class="btn-primary" #btn_Set [tabindex]="0" (click)="eventSet_CLICKHandler()">設定</button>
  </footer>
</div>